import { UtilsService } from '@common/services';

export class ShortRecipient
{
    public email: string;
    public firstName: string = '';
    public lastName: string = '';
    public displayName: string;
    public id: string;
    public firstLastNameAddress: string;

    constructor (email?: string, firstName?: string, lastName?: string)
    {
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.displayName = `${this.firstName ?? ''} ${this.lastName ?? ''}`;
        this.firstLastNameAddress = !UtilsService.isNullOrEmpty(this.email) ? `${this.displayName} <${this.email}>` : this.displayName;
    }

    public static mapperFromObject (source: any): ShortRecipient
    {
        const target = new ShortRecipient(source.email, source.firstName, source.lastName);

        Object.assign(target, source);

        return target;
    }
}
